import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, FacebookIcon, MailIcon, RssIcon, UsersRoundIcon, YoutubeIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerInfo } from '../data/homepage';
const heading = 'font-display text-2xl font-extrabold tracking-tight text-ville-lime';
const social = 'grid h-9 w-9 place-items-center rounded-full bg-ville-spring text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring focus-visible:ring-offset-2 focus-visible:ring-offset-ville-navy';
export function Footer() {
  return <footer className="w-full bg-ville-navy text-white" data-id="element-1214" data-mp="3le2fmgombj5f">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-14 text-center lg:grid-cols-3 lg:px-10" data-id="element-1215" data-mp="3qcnjqr6zqmz5">
        <div data-id="element-1216" data-mp="29y5gjzn2fiuh">
          <h2 className={heading} data-id="element-1217" data-mp="29xlz0k1buwgz">Address</h2>
          <p className="mt-4 font-bold" data-id="element-1218" data-mp="2ey9x1pnz4dkp">{footerInfo.name}</p>
          {footerInfo.address.map(line => <p key={line} className="text-white/90" data-id="element-1219" data-mp="3l9k65dxrvpdt">
              {line}
            </p>)}
          <p className="mt-6 flex justify-center" data-id="element-1220" data-mp="3lbddkvg7mdmv">
            <Logo variant="light" data-id="element-1221" data-mp="3gbimaqsivm1a" />
          </p>
        </div>

        <div data-id="element-1222" data-mp="3v7gejxzbs688">
          <h2 className={heading} data-id="element-1223" data-mp="3v89f2h7oxzhx">Contact</h2>

          <dl className="mt-4 space-y-4" data-id="element-1224" data-mp="3v91b1t579z8q">
            <div className="flex items-start justify-center gap-3 text-left" data-id="element-1225" data-mp="3q8wu620dr2hz">
              <MailIcon className="mt-0.5 h-6 w-6 shrink-0" aria-hidden="true" data-id="element-1226" data-mp="3qazo2x4nlfrz" />
              <div className="min-w-0" data-id="element-1227" data-mp="80xjq7w8kzj3">
                <dt className="font-bold text-ville-lime" data-id="element-1228" data-mp="34gvldp1el60">Inquiry Email:</dt>
                <dd data-id="element-1229" data-mp="hstv2knc2m59">
                  <a href={`mailto:${footerInfo.inquiryEmail}`} className="break-all text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1230" data-mp="htd236bg3q4i">
                    {footerInfo.inquiryEmail}
                  </a>
                </dd>
              </div>
            </div>

            <div className="flex items-start justify-center gap-3 text-left" data-id="element-1231" data-mp="msy45plwwelg">
              <CreditCardIcon className="mt-0.5 h-6 w-6 shrink-0" aria-hidden="true" data-id="element-1232" data-mp="tvmnzb2xs4iq" />
              <div className="min-w-0" data-id="element-1233" data-mp="ytxylo122j20">
                <dt className="font-bold text-ville-lime" data-id="element-1234" data-mp="yuz9nsi2n5jq">Payment Email:</dt>
                <dd data-id="element-1235" data-mp="13t0sqdfhz4v7">
                  <a href={`mailto:${footerInfo.paymentEmail}`} className="break-all text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1236" data-mp="13sisl5pps6i0">
                    {footerInfo.paymentEmail}
                  </a>
                </dd>
              </div>
            </div>
          </dl>

          <p className="mt-5 font-bold" data-id="element-1237" data-mp="1hmibhw0d0dk6">
            No Charge:{' '}
            <a href={`tel:${footerInfo.tollFree}`} className="font-normal hover:text-ville-spring" data-id="element-1238" data-mp="1mkbmr3girxrb">
              {footerInfo.tollFree}
            </a>
          </p>
          <p className="font-bold" data-id="element-1239" data-mp="3obx1fbjbcuuc">
            Phone:{' '}
            <a href={`tel:${footerInfo.phone}`} className="font-normal hover:text-ville-spring" data-id="element-1240" data-mp="3odhvl01pubro">
              {footerInfo.phone}
            </a>
          </p>

          <ul className="mt-5 flex justify-center gap-3" data-id="element-1241" data-mp="2afwz4q22lr18">
            <li data-id="element-1242" data-mp="25onbfv030xrz">
              <a href="#accueil" aria-label="News feed" className={social} data-id="element-1243" data-mp="25o56m9zctb8g">
                <RssIcon className="h-4 w-4" aria-hidden="true" data-id="element-1244" data-mp="21mjzz6dext6p" />
              </a>
            </li>
            <li data-id="element-1245" data-mp="1wnz0xa9wdfju">
              <a href="#accueil" aria-label="Facebook" className={social} data-id="element-1246" data-mp="1woi7xvy0ejj3">
                <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-1247" data-mp="2tdptv52jiunj" />
              </a>
            </li>
            <li data-id="element-1248" data-mp="2pcnu8n4pogl1">
              <a href="#accueil" aria-label="YouTube" className={social} data-id="element-1249" data-mp="2pc4mfz8rz8kq">
                <YoutubeIcon className="h-4 w-4" aria-hidden="true" data-id="element-1250" data-mp="2kd1f285boq9l" />
              </a>
            </li>
          </ul>

          <div className="mt-5 flex flex-wrap justify-center gap-3" data-id="element-1251" data-mp="2fezwdobt6syn">
            <Link to="/my-dashboard" className="inline-flex items-center gap-2 rounded-full bg-ville-blue px-4 py-2 text-sm font-bold text-white transition-colors duration-150 ease-ville hover:bg-ville-spring hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1252" data-mp="18y4norlo1oz2">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-white font-display text-[13px] font-extrabold leading-none text-ville-blue" aria-hidden="true" data-id="element-1253" data-mp="2wmg1z369m1ip">
                b
              </span>
              My Account
            </Link>
            <a href="#accueil" className="inline-flex items-center gap-2 rounded-full bg-ville-blue px-4 py-2 text-sm font-bold text-white transition-colors duration-150 ease-ville hover:bg-ville-spring hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1254" data-mp="2nunqcp5i8mcj">
              <UsersRoundIcon className="h-4 w-4" aria-hidden="true" data-id="element-1255" data-mp="31l0yariec11v" />
              Employee
            </a>
          </div>
        </div>

        <div data-id="element-1256" data-mp="1q6dpidhgg4n0">
          <h2 className={heading} data-id="element-1257" data-mp="1q5uivsx992oa">Hours of Operation:</h2>
          {footerInfo.hours.map(line => <p key={line} className="mt-1 text-white/90" data-id="element-1258" data-mp="1v574698ha1or">
              {line}
            </p>)}

          <h2 className={`mt-6 ${heading}`} data-id="element-1259" data-mp="1nlxx4mng2f2v">Regional</h2>
          <ul className="mt-2 space-y-1" data-id="element-1260" data-mp="1nkedqn6hrnwv">
            {footerInfo.regional.map(label => <li key={label} data-id="element-1261" data-mp="1iltd4mnbv27w">
                <a href="#accueil" className="text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1262" data-mp="1imlaa1wkp80a">
                  {label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15" data-id="element-1263" data-mp="13z0604nyp2qs">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-5 py-5 text-sm lg:px-10" data-id="element-1264" data-mp="13vm22rznglh8">
          <p className="font-semibold" data-id="element-1265" data-mp="1dobcdjjgrtaz">© 2026 {footerInfo.name}</p>
          <p className="font-bold" data-id="element-1266" data-mp="1dpuqb3hnds9l">
            Powered by{' '}
            <a href="#accueil" className="text-ville-spring underline-offset-4 hover:underline" data-id="element-1267" data-mp="18w9thersj4bz">
              {footerInfo.poweredBy}
            </a>
          </p>
        </div>
      </div>
    </footer>;
}